import { render, staticRenderFns } from "./StoryFirmListPage.vue?vue&type=template&id=71a54704&scoped=true&"
import script from "./StoryFirmListPage.vue?vue&type=script&lang=js&"
export * from "./StoryFirmListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a54704",
  null
  
)

export default component.exports